import React, { useState } from 'react';
import { FileText } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { CITE_TYPES, CiteType, FIELDS, buildCitation } from './iso690';

const input = 'w-full rounded-md border border-neutral-300 px-2.5 py-1.5 text-[13px] outline-none focus:border-blue-600 transition-colors';

export function CitationBuilder({ onApply, testId }: { onApply: (t: string) => void; testId: string }) {
  const [open, setOpen] = useState(false);
  const [type, setType] = useState<CiteType>('web');
  const [f, setF] = useState<Record<string, string>>({});
  const preview = buildCitation(type, f);
  const filled = Object.values(f).some((x) => x.trim());
  const apply = () => { onApply(preview); setOpen(false); setF({}); };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button data-testid={`${testId}-iso`} className="inline-flex shrink-0 items-center gap-1 rounded-full bg-blue-600 px-2 py-[2px] font-ui text-[11px] font-semibold text-white hover:bg-blue-500 transition-colors">
          <FileText size={11} /> ISO 690
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-[440px] p-3 font-ui" align="start" data-testid={`${testId}-iso-form`} onKeyDown={(e) => e.stopPropagation()}>
        <p className="mb-2 text-xs font-semibold uppercase tracking-wider text-neutral-500">Citation au format ISO 690</p>
        <select data-testid={`${testId}-iso-type`} className={input} value={type} onChange={(e) => { setType(e.target.value as CiteType); setF({}); }}>
          {CITE_TYPES.map((t) => <option key={t.id} value={t.id}>{t.label}</option>)}
        </select>
        <div className="mt-2 grid grid-cols-2 gap-2">
          {FIELDS[type].map((fl) => (
            <label key={fl.id} className={`flex flex-col gap-0.5 ${fl.id === 'title' || fl.id === 'url' || fl.id === 'court' ? 'col-span-2' : ''}`}>
              <span className="text-[11px] font-semibold text-neutral-500">{fl.label}</span>
              <input data-testid={`${testId}-iso-${fl.id}`} className={input} placeholder={fl.ph} value={f[fl.id] || ''} onChange={(e) => setF({ ...f, [fl.id]: e.target.value })} />
            </label>
          ))}
        </div>
        <div className="mt-3 rounded-md bg-neutral-100 p-2 text-[12px] leading-snug text-neutral-800" data-testid={`${testId}-iso-preview`}>{filled ? preview : <span className="text-neutral-400">L'aperçu de la citation s'affiche ici. La date de consultation est ajoutée automatiquement pour les sources en ligne.</span>}</div>
        <button data-testid={`${testId}-iso-apply`} disabled={!filled} onClick={apply} className="mt-2 w-full rounded-full bg-black py-2 font-app text-[13px] font-semibold text-white hover:bg-blue-600 disabled:opacity-40 transition-colors">Utiliser cette citation</button>
      </PopoverContent>
    </Popover>
  );
}
